import API from '../../clients/api'

const fetchLearningPaths = async () => {
  const route = `paths?embed=difficulties`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchSelectedLearningPath = async id => {
  const route = `paths/${id}?embed=difficulties,groups.courses.track.vendor,groups.courses.presenter,groups.courses.totalCourseVideos`
  return API.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export { fetchLearningPaths, fetchSelectedLearningPath }
